<template>
  <router-view v-if="loadedRoutes"></router-view>
</template>

<script>
  import Vue from 'vue'
  import {cloneDeepWith, isString, isObject, set,merge} from 'lodash';
  import {forOwnWithPath,transformStrByEval} from '@/utils/commonUtils'

  import draggable from 'vuedraggable'
  Vue.component("draggable", draggable)

  import {DatePicker} from 'element-ui'
  import 'element-ui/lib/theme-chalk/date-picker.css';
  import 'element-ui/lib/theme-chalk/button.css'; // для кооректного отображения button у date-picker

  import lang from 'element-ui/lib/locale/lang/ru-RU'
  import locale from 'element-ui/lib/locale'
  locale.use(lang)

  Vue.component("el-date-picker", DatePicker)


  //////////////////////////////
  // import Routes from './routes'

  export default {
    name: 'app',
    data() {
      return {
        loadedRoutes: false
      }
    },
    created() {
      const self = this;
      this.$axios.get("/layout/routes.json").then(responce => responce.data).then(data => {

        ////////////////////////
        // data = Routes;

        const promisesForLoadinngData = {};
        const getDataJsonWithCache = (url) => {
          if (!promisesForLoadinngData[url]) promisesForLoadinngData[url] = this.$axios.get(url)
            .then(responce => responce.data).then(data => {
              return data;
            })

          return promisesForLoadinngData[url];

        }

        const jsonVars={}
        data.filter(route=>route.$vars).forEach(route=>merge(jsonVars,route.$vars))



        const reolverDataJson = (srcJson, params) => {

          const result = srcJson.constructor();

          const promises = [];

          forOwnWithPath(srcJson, (path, v, key, obj) => {

            if (isString(v)) {
              const startIndex = v.indexOf("#{");
              let endIndex = -1;
              let b = false;
              if (startIndex > -1) {
                endIndex = v.indexOf("}#", startIndex)
                b = endIndex > 0;
                if (!b) endIndex = v.indexOf("}", startIndex)//Оставляем обратную совместимость
              }
              if (startIndex > -1 && endIndex > -1) {
                const paramNameAndDefaultValue = v.substring(startIndex + 2, endIndex).split("||");
                const paramName = paramNameAndDefaultValue[0].trim();
                const defValue = typeof paramNameAndDefaultValue[1] !== "undefined" ? paramNameAndDefaultValue[1].trim() : undefined;
                if (params[paramName]==undefined && !defValue) {
                  console.warn("Params name " + paramName + " not found for path " + path + " Json:" + JSON.stringify(srcJson, null, 2));
                }
                let newVal = isString(params[paramName]) ? v.replace(v.substring(startIndex, endIndex + (b ? 2 : 1)), params[paramName] || defValue) : params[paramName] || defValue
                if (newVal=='{}') newVal={}
                set(result, path, newVal)
                return true
              }
            }



            if (isObject(v) && v.$url) {

              promises.push(getDataJsonWithCache(v.$url).then(data => {
                return reolverDataJson(v.params || {}, params).then(params => {
                  return reolverDataJson(data, params)
                }).then(val => {
                  return set(result, path, val)
                })
              }))

              return true;
            }

            typeof(v) == 'object' && v != null
              ? set(result, path, v.constructor())
              : set(result, path, v)

          });

          return Promise.all(promises).then(d => result);
        }

        reolverDataJson(data, jsonVars).then(resolvedRoutes => {
          //console.log(resolvedRoutes)

          let handledRoutes = cloneDeepWith(resolvedRoutes, (propValue, propName) => {
            if (propName == "component" && isObject(propValue)) {
              return {
                data() {
                  return propValue.params ? propValue.params.props : {};//Добавляем реактивности при изменении props
                },
                render(createElement) {
                  return createElement(propValue.component, propValue.params || {})
                }
              }
            }
          });

          handledRoutes.filter(route=>route.$expression).forEach(route=>transformStrByEval(route.$expression,{"vue":self}))
          handledRoutes = handledRoutes.filter(route=>route.path);

          self.$router.addRoutes(handledRoutes);
          self.$router.push(self.$route.path);
          self.loadedRoutes = true;
        })
      }).catch(e => console.warn(e))
    }
  }
</script>

<style>
  .app-centerContent {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<style>
  @import "~semantic-ui-css/components/reset.css";
  @import "~semantic-ui-css/components/site.css";
  @import "~semantic-ui-css/components/sidebar.css";
  @import "~semantic-ui-css/components/tab.css";
  @import "~semantic-ui-css/components/menu.css";
  @import "~semantic-ui-css/components/item.css";
  @import "~semantic-ui-css/components/dropdown.css";
  @import "~semantic-ui-css/components/transition.css";
  @import "~semantic-ui-css/components/image.css";
  @import "~semantic-ui-css/components/icon.css";
  @import "~semantic-ui-css/components/button.css";
  @import "~semantic-ui-css/components/divider.css";
  @import "~semantic-ui-css/components/header.css";
  @import "~semantic-ui-css/components/input.css";
  @import "~semantic-ui-css/components/form.css";
  @import "~semantic-ui-css/components/table.css";
  @import "~semantic-ui-css/components/search.css";
  @import "~semantic-ui-css/components/checkbox.css";
  @import "~semantic-ui-css/components/label.css";
  @import "~semantic-ui-css/components/grid.css";
  @import "~semantic-ui-css/components/popup.css";
  @import "~semantic-ui-css/components/modal.css";
  @import "~semantic-ui-css/components/dimmer.css";
  @import "~semantic-ui-css/components/list.css";
  @import "~semantic-ui-css/components/loader.css";
</style>

